// portal.js — Rhythmixed Client Portal
'use strict';

// ── renderDashboard ───────────────────────────────────────────────────────────

function renderDashboard(root, ctx, order, creds) {
  root.innerHTML = '';
  var isLocked = order.submissionLocked === true || order.submissionLocked === 'true';

  var trackCount = parseInt(order.tracks, 10);
  if (!isFinite(trackCount) || trackCount < 1) trackCount = 1;

  var limit           = epLimit(order);
  var maxEffectLevels = (order.maxEffectLevels && parseInt(order.maxEffectLevels, 10)) || 5;

  var introOptions      = (order.transitions && toOptions(order.transitions.intro))      || FALLBACK_INTRO_OPTIONS;
  var transitionOptions = (order.transitions && toOptions(order.transitions.transition)) || FALLBACK_TRANSITION_OPTIONS;
  var outroOptions      = (order.transitions && toOptions(order.transitions.outro))      || FALLBACK_OUTRO_OPTIONS;

  var addOnList = splitAddOns(order.addOns);

  // Restore track state from backend
  var existing = [];
  var parsedSubmission = safeParseJson(order.submissionData);
  if (Array.isArray(parsedSubmission)) existing = parsedSubmission;

  var tracks = [];
  for (var i = 0; i < trackCount; i++) {
    var ex = existing[i] || {};
    var td = {
      track:       i + 1,
      title:       ex.title      || '',
      fileUrl:     ex.fileUrl    || null,
      effectLevel: ex.effectLevel || 1,
      editPoints:  Array.isArray(ex.editPoints)
        ? ex.editPoints.map(function (ep) { return { start: ep.start || '', end: ep.end || '' }; })
        : [],
      notes:    ex.notes    || '',
      complete: false,
      acapellaInstructions:           ex.acapellaInstructions           || '',
      removeNoiseInstructions:        ex.removeNoiseInstructions        || '',
      customDanceBreakInstructions:   ex.customDanceBreakInstructions   || '',
    };
    td.complete = trackIsComplete(td);
    tracks.push(td);
  }

  // Restore edit structure from backend
  var editStructure = {
    intro:       introOptions[0]      ? introOptions[0].value      : 'None',
    transitions: [],
    outro:       outroOptions[0]      ? outroOptions[0].value      : 'None',
    addOns: {
      bpm: '', key: { note: 'A', type: 'Major' },
      customIntro: '', customOutro: '',
      acapella: '', acapellaTrack: '',
      removeNoise: '', removeNoiseTrack: '',
      customDanceBreak: '', other: {},
    },
  };
  for (var g = 0; g < trackCount - 1; g++) {
    editStructure.transitions.push(transitionOptions[0] ? transitionOptions[0].value : FALLBACK_TRANSITION_OPTIONS[0].value);
  }
  var parsedEs = safeParseJson(order.editStructure);
  if (parsedEs && typeof parsedEs === 'object' && !Array.isArray(parsedEs)) {
    if (parsedEs.intro) editStructure.intro = parsedEs.intro;
    if (Array.isArray(parsedEs.transitions)) {
      for (var ti = 0; ti < trackCount - 1; ti++) {
        editStructure.transitions[ti] = parsedEs.transitions[ti] || editStructure.transitions[ti];
      }
    }
    if (parsedEs.outro) editStructure.outro = parsedEs.outro;
    if (parsedEs.addOns && typeof parsedEs.addOns === 'object') {
      editStructure.addOns = Object.assign(editStructure.addOns, parsedEs.addOns);
    }
  }

  // Sanitise restored editStructure values against package-allowed options.
  // Also migrates old label-format values to the new value-field format.
  (function sanitiseEditStructure() {
    function resolveOption(saved, options) {
      if (!options.length) return saved;
      // 1. Exact match on value (new format)
      if (options.some(function (o) { return o.value === saved; })) return saved;
      // 2. Case-insensitive match on value
      var lc = saved ? saved.toLowerCase() : '';
      var byValue = options.find(function (o) { return o.value.toLowerCase() === lc; });
      if (byValue) return byValue.value;
      // 3. Match on label (old format — migrate to value)
      var byLabel = options.find(function (o) { return o.label.toLowerCase() === lc; });
      if (byLabel) return byLabel.value;
      // 4. Starts-with match on label (old format had descriptions appended)
      var byPrefix = options.find(function (o) {
        return lc.indexOf(o.label.toLowerCase()) === 0 || o.label.toLowerCase().indexOf(lc) === 0;
      });
      if (byPrefix) return byPrefix.value;
      // 5. Not found — reset to first allowed option
      return options[0].value;
    }

    editStructure.intro = resolveOption(editStructure.intro, introOptions);
    editStructure.outro = resolveOption(editStructure.outro, outroOptions);
    for (var si = 0; si < editStructure.transitions.length; si++) {
      editStructure.transitions[si] = resolveOption(editStructure.transitions[si], transitionOptions);
    }
  })();



  // ── Autosave ──
  var autoSaveTimer = null;
  function autoSave() {
    if (isLocked) return;
    if (autoSaveTimer) clearTimeout(autoSaveTimer);
    autoSaveTimer = setTimeout(function () {
      apiPost(ctx.apiBase, '/submit-files', {
        orderNumber: creds.orderNumber,
        token:       creds.token || null,
        email:       creds.email || null,
        tracks:      tracks,
        editStructure: editStructure,
        allTracksComplete: tracks.every(function (t) { return t.complete; }),
        isFinalSubmission: false,
      }).catch(function () {});
    }, 800);
  }

  // ── Top bar ──
  var statusBarEl = buildStatusBar(order.status, isLocked);

  var refreshBtn = el('button', { class: 'ce-btn ce-btn-outline ce-btn-sm', text: 'Refresh status', type: 'button' });
  var logoutBtn  = creds.email
    ? el('button', { class: 'ce-btn ce-btn-outline ce-btn-sm', text: 'Back', type: 'button', style: 'margin-right:8px;' })
    : null;

  if (logoutBtn) {
    logoutBtn.addEventListener('click', function () {
      sessionStorage.removeItem('ce_token');
      sessionStorage.removeItem('ce_order');
      renderLanding(root, ctx.apiBase, ctx.uploadcareKey, function (body, newCreds) {
        if (newCreds.token) sessionStorage.setItem('ce_token', newCreds.token);
        sessionStorage.setItem('ce_order', newCreds.orderNumber);
        renderDashboard(root, ctx, body, newCreds);
      });
    });
  }

  var topBar = el('div', { class: 'ce-top-bar' }, [
    el('div', {}, [
      el('p',  { class: 'ce-eyebrow', text: 'Order #' + order.orderNumber }),
      el('h1', { class: 'ce-h1',      text: order.editTitle || ('Order #' + order.orderNumber) }),
    ]),
    el('div', { style: 'display:flex;gap:8px;align-items:center;' }, [logoutBtn, refreshBtn].filter(Boolean)),
  ]);
  root.appendChild(topBar);
  root.appendChild(statusBarEl);

  var lockedBannerEl = null;
  if (isLocked) {
    lockedBannerEl = buildLockedBanner(ctx.apiBase, creds, function () {});
    root.appendChild(lockedBannerEl);
  }

  // ── Tab system ──
  var tabBar  = el('div', { class: 'ce-tabs' });
  var tabWrap = el('div', { class: 'ce-tab-wrap' });
  var panels = [], tabBtns = [];

  function activateTab(idx) {
    panels.forEach(function (p, i) {
      if (i === idx) {
        p.classList.add('is-active');
        attachScrollReveal(p);
      } else {
        p.classList.remove('is-active');
      }
    });
    tabBtns.forEach(function (b, i) {
      if (i === idx) b.classList.add('is-active'); else b.classList.remove('is-active');
    });
  }

  function addTab(label, panel) {
    var idx = panels.length;
    var btn = el('button', { class: 'ce-tab', text: label, type: 'button' });
    btn.addEventListener('click', function () { activateTab(idx); });
    tabBar.appendChild(btn);
    tabBtns.push(btn);
    panels.push(panel);
    tabWrap.appendChild(panel);
    return btn;
  }

  // ── Sub-tab system (Build Your Edit) ──
  var custSubPanels = [], custSubBtns = [];
  var custSubWrap = el('div', { class: 'ce-sub-wrap' });
  var custSubBar  = el('div', { class: 'ce-sub-tabs' });

  function activateSubTab(idx) {
    custSubPanels.forEach(function (p, i) {
      if (i === idx) p.classList.add('is-active'); else p.classList.remove('is-active');
    });
    custSubBtns.forEach(function (b, i) {
      if (i === idx) b.classList.add('is-active'); else b.classList.remove('is-active');
    });
    if (custSubPanels[idx]) attachScrollReveal(custSubPanels[idx]);
  }

  function addSubTab(label, panel) {
    var idx = custSubPanels.length;
    var btn = el('button', { class: 'ce-sub-tab', text: label, type: 'button' });
    btn.addEventListener('click', function () { activateSubTab(idx); });
    custSubBar.appendChild(btn);
    custSubBtns.push(btn);
    custSubPanels.push(panel);
    custSubWrap.appendChild(panel);
    return btn;
  }

  var trackSubBtns = [];
  function trackSubLabel(i) {
    return tracks[i].complete ? 'Track ' + (i + 1) + ' ✓' : '⚠ Track ' + (i + 1);
  }

  var refreshIncomplete  = null;
  var refreshFlowDisplay = null;

  function refreshTrackLabels() {
    trackSubBtns.forEach(function (b, i) {
      b.textContent = trackSubLabel(i);
      if (tracks[i].complete) b.classList.remove('is-incomplete');
      else b.classList.add('is-incomplete');
    });
    var allDone = tracks.every(function (t) { return t.complete; });
    submitBtn.disabled     = !allDone;
    submitBtn.style.opacity = allDone ? '1' : '0.6';
    if (typeof refreshIncomplete  === 'function') refreshIncomplete();
    if (typeof refreshFlowDisplay === 'function') refreshFlowDisplay();
  }

  function goToTrack(i)    { activateTab(1); activateSubTab(i); }
  function goToTransitions() { activateTab(1); activateSubTab(trackCount); }

  // ── Submit button (shared ref passed to Overview) ──
  var submitMsg = el('p', { class: 'ce-help', style: 'margin-top:8px;min-height:20px;' });
  var submitBtn = el('button', { class: 'ce-btn ce-btn-primary', text: 'Submit my edit', type: 'button' });
  submitBtn.disabled      = true;
  submitBtn.style.opacity = '0.6';
  if (isLocked) submitBtn.style.display = 'none';

  // ── Build tabs ──
  var overviewPanel = el('div', { class: 'tab-panel' });
  addTab('Overview', overviewPanel);

  var custPanel = el('div', { class: 'tab-panel' });
  addTab('Build Your Edit', custPanel);
  custPanel.appendChild(custSubBar);
  custPanel.appendChild(custSubWrap);

  for (var t = 0; t < trackCount; t++) {
    (function (idx) {
      var sp  = el('div', { class: 'sub-panel' });
      var btn = addSubTab(trackSubLabel(idx), sp);
      trackSubBtns.push(btn);
      buildTrackPanel(sp, {
        td:             tracks[idx],
        limit:          limit,
        maxEffectLevels: maxEffectLevels,
        uploadcareKey:  ctx.uploadcareKey,
        onChange:       refreshTrackLabels,
        autoSave:       autoSave,
        trackCount:     trackCount,
        trackIdx:       idx,
        isLocked:       isLocked,
        goToNextSubTab: function () { activateSubTab(idx + 1); },
      });
    })(t);
  }

  var transSubPanel  = el('div', { class: 'sub-panel' });
  addSubTab('Transitions', transSubPanel);

  var addonsSubPanel = el('div', { class: 'sub-panel' });
  addSubTab('Add-ons', addonsSubPanel);

  activateSubTab(0);

  var helpPanel = el('div', { class: 'tab-panel' });
  addTab('Help', helpPanel);

  var dlPanel = el('div', { class: 'tab-panel' });
  addTab('Download', dlPanel);

  // ── Wire up panels ──
  var overviewRefs = buildOverview(overviewPanel, {
    order:             order,
    tracks:            tracks,
    editStructure:     editStructure,
    addOnList:         addOnList,
    submitBtn:         submitBtn,
    submitMsg:         submitMsg,
    autoSave:          autoSave,
    introOptions:      introOptions,
    transitionOptions: transitionOptions,
    outroOptions:      outroOptions,
    goToTrack:         goToTrack,
    goToTransitions:   goToTransitions,
  });
  refreshIncomplete  = overviewRefs.refreshIncomplete;
  refreshFlowDisplay = overviewRefs.refreshFlowDisplay;

  buildTransitionsPanel(transSubPanel, {
    editStructure:     editStructure,
    introOptions:      introOptions,
    transitionOptions: transitionOptions,
    outroOptions:      outroOptions,
    tracks:            tracks,
    addOnList:         addOnList,
    autoSave:          autoSave,
    activateTab:       activateTab,
    goToAddOns:        function () { activateSubTab(trackCount + 1); },
    onTransitionChange: function () {
      if (typeof refreshFlowDisplay === 'function') refreshFlowDisplay();
    },
  });

  buildAddOnsPanel(addonsSubPanel, {
    addOnList:    addOnList,
    editStructure: editStructure,
    autoSave:     autoSave,
    trackCount:   trackCount,
    activateTab:  activateTab,
    onAddOnChange: function () {
      if (typeof refreshIncomplete === 'function') refreshIncomplete();
    },
  });

  buildHelpPanel(helpPanel, {
    tracks:          tracks,
    order:           order,
    activateTab:     activateTab,
    goToTransitions: goToTransitions,
  });

  buildDownloadSection(dlPanel, order, {
    tracks:      tracks,
    activateTab: activateTab,
    onRefresh:   function () { refreshBtn.click(); },
  });

  root.appendChild(tabBar);
  root.appendChild(tabWrap);

  // ── Submit handler ──
  submitBtn.addEventListener('click', function () {
    if (!tracks.every(function (t) { return t.complete; })) return;
    submitBtn.disabled     = true;
    submitBtn.textContent  = 'Submitting…';
    apiPost(ctx.apiBase, '/submit-files', {
      orderNumber:       creds.orderNumber,
      token:             creds.token || null,
      email:             creds.email || null,
      tracks:            tracks,
      editStructure:     editStructure,
      allTracksComplete: true,
      isFinalSubmission: true,
    }).then(function (res) {
      submitBtn.disabled    = false;
      submitBtn.textContent = 'Submit my edit';
      if (!res.ok || !res.body || res.body.error) {
        submitMsg.style.color = 'var(--ce-red)';
        submitMsg.textContent = (res.body && res.body.error) || 'Submission failed. Please try again.';
        return;
      }
      order.status           = res.body.status || 'submitted';
      order.submissionLocked = true;
      // Full re-render so all track panels, inputs and buttons reflect locked state immediately
      renderDashboard(root, ctx, order, creds);
      return;
    }).catch(function () {
      submitBtn.disabled    = false;
      submitBtn.textContent = 'Submit my edit';
      submitMsg.style.color = 'var(--ce-red)';
      submitMsg.textContent = 'Could not reach the server. Please try again.';
    });
  });

  // ── Refresh handler ──
  refreshBtn.addEventListener('click', function () {
    refreshBtn.disabled    = true;
    refreshBtn.textContent = 'Refreshing…';
    apiGet(ctx.apiBase, '/order-status', {
      orderNumber: creds.orderNumber,
      token:       creds.token || null,
      email:       creds.email || null,
    }).then(function (res) {
      refreshBtn.disabled    = false;
      refreshBtn.textContent = 'Refresh status';
      if (res.ok && res.body && !res.body.error) {
        order.status      = res.body.status || order.status;
        // Defensive: check all possible field names the backend may use
        order.deliveryUrl    = res.body.deliveryUrl || res.body.downloadUrl || res.body.delivery_url || res.body.fileUrl || order.deliveryUrl;
        order.submissionLocked = res.body.submissionLocked;
        var newLocked = res.body.submissionLocked === true || res.body.submissionLocked === 'true';
        if (newLocked !== isLocked) {
          // Lock state changed — full re-render is the cleanest approach
          isLocked = newLocked;
          renderDashboard(root, ctx, order, creds);
          return;
        }
        var newBar = buildStatusBar(order.status, isLocked);
        statusBarEl.parentNode.replaceChild(newBar, statusBarEl);
        statusBarEl = newBar;
        dlPanel.innerHTML = '';
        buildDownloadSection(dlPanel, order, {
          tracks: tracks, activateTab: activateTab, onRefresh: function () { refreshBtn.click(); },
        });
      }
    }).catch(function () {
      refreshBtn.disabled    = false;
      refreshBtn.textContent = 'Refresh status';
    });
  });

  activateTab(0);
  refreshTrackLabels();
}

// ── buildOverview ─────────────────────────────────────────────────────────────

function buildOverview(panel, o) {

  // Next-step callout
  var nextStepEl = el('div', { class: 'ce-next-step' });

  function buildNextStep() {
    nextStepEl.innerHTML = '';
    var firstIncomplete = null;
    for (var i = 0; i < o.tracks.length; i++) {
      if (!o.tracks[i].complete) { firstIncomplete = i; break; }
    }
    var isSubmitted = ['submitted', 'ready', 'completed'].indexOf(o.order.status) !== -1;

    var hdEl = el('div', { class: 'ce-next-step-hd' });
    var bdEl = el('div', { class: 'ce-next-step-bd' });
    var copyEl   = el('div', { class: 'ce-next-step-copy' });
    var actionEl = el('div', { class: 'ce-next-step-action' });

    if (isSubmitted) {
      hdEl.appendChild(el('div', {}, [
        el('div', { class: 'ce-next-step-eyebrow',  text: 'STATUS' }),
        el('div', { class: 'ce-next-step-heading',  text: 'Your edit has been submitted' }),
      ]));
      copyEl.textContent = 'We\'re working on your edit. Check the Download tab for updates.';
    } else if (firstIncomplete !== null) {
      var trackNum = firstIncomplete + 1;
      hdEl.appendChild(el('div', {}, [
        el('div', { class: 'ce-next-step-eyebrow', text: 'YOUR NEXT STEP' }),
        el('div', { class: 'ce-next-step-heading', text: 'Track ' + trackNum + ' needs your details' }),
      ]));
      copyEl.textContent = 'Upload your track, choose edit points, and add any notes for the editor.';
      var ctaBtn = el('button', { class: 'ce-btn ce-btn-primary', text: 'Complete Track ' + trackNum + ' →', type: 'button' });
      (function (idx) { ctaBtn.addEventListener('click', function () { o.goToTrack(idx); }); })(firstIncomplete);
      actionEl.appendChild(ctaBtn);
    } else {
      hdEl.appendChild(el('div', {}, [
        el('div', { class: 'ce-next-step-eyebrow', text: 'YOUR NEXT STEP' }),
        el('div', { class: 'ce-next-step-heading', text: 'All tracks complete — ready to submit' }),
      ]));
      copyEl.textContent = 'Review your edit below, then submit when ready.';
      actionEl.appendChild(o.submitBtn);
      if (o.submitMsg) actionEl.appendChild(o.submitMsg);
    }

    bdEl.appendChild(copyEl);
    bdEl.appendChild(actionEl);
    nextStepEl.appendChild(hdEl);
    nextStepEl.appendChild(bdEl);
  }


  buildNextStep();
  panel.appendChild(nextStepEl);

  // Timeline heading
  panel.appendChild(el('div', { class: 'ce-section-hd' }, [
    el('div', { class: 'ce-section-hd-title', text: 'Order at a glance' }),
    el('div', { class: 'ce-section-hd-divider' }),
  ]));

  // Timeline
  var flowDisplayUpdaters = [];
  var timelineEl = el('ol', { class: 'ce-timeline' });
  // ── Timeline (continued from buildOverview) ───────────────────────────────

  // Intro boundary
  var introNameEl = el('span', { class: 'ce-ep-boundary-name' });
  flowDisplayUpdaters.push(function () {
    var opt = o.introOptions.find(function (x) { return x.value === o.editStructure.intro; });
    introNameEl.textContent = opt ? opt.label : o.editStructure.intro;
  });
  var introBtn = el('button', { class: 'ce-ep-boundary', type: 'button' }, [
    el('span', { class: 'ce-ep-boundary-tag',  text: 'INTRO' }),
    introNameEl,
  ]);
  introBtn.addEventListener('click', function () { o.goToTransitions(); });
  timelineEl.appendChild(el('li', { class: 'ce-timeline-step ce-timeline-step--intro' }, [introBtn]));

  // Track rows + transition markers
  o.tracks.forEach(function (td, i) {
    var rowNumEl    = el('div', { class: 'ce-track-row-num',    text: String(i + 1).padStart(2, '0') });
    var rowTitleEl  = el('div', { class: 'ce-track-row-title' });
    var rowMetaEl   = el('div', { class: 'ce-track-row-meta' });
    var rowStatusEl = el('div', { class: 'ce-track-row-status' });
    var rowActionEl = el('div', { class: 'ce-track-row-action' });

    var trackRow = el('div', { class: 'ce-track-row' }, [
      rowNumEl,
      el('div', { class: 'ce-track-row-body' }, [rowTitleEl, rowMetaEl]),
      el('div', { style: 'display:flex;align-items:center;flex-shrink:0;' }, [rowStatusEl, rowActionEl]),
    ]);

    function makeUpdateRow(tdRef, rowEl, titleEl, metaEl, statusEl, actionEl) {
      return function () {
        var eff = EFFECT_LEVELS[tdRef.effectLevel] || EFFECT_LEVELS[1];
        titleEl.textContent = tdRef.title || 'Untitled track';
        metaEl.textContent  = eff.label + ' effects';
        if (tdRef.complete) {
          rowEl.className    = 'ce-track-row is-complete';
          statusEl.className = 'ce-track-row-status is-complete';
          statusEl.textContent = '✓ Complete';
          actionEl.textContent = '  Edit track →';
        } else {
          rowEl.className    = 'ce-track-row is-incomplete';
          statusEl.className = 'ce-track-row-status is-incomplete';
          statusEl.textContent = '⚠ Needs details';
          actionEl.textContent = '  Complete this track →';
        }
      };
    }

    var updateRow = makeUpdateRow(td, trackRow, rowTitleEl, rowMetaEl, rowStatusEl, rowActionEl);
    updateRow();
    flowDisplayUpdaters.push(updateRow);

    (function (trackIdx) {
      trackRow.addEventListener('click', function () { o.goToTrack(trackIdx); });
    })(i);

    timelineEl.appendChild(el('li', { class: 'ce-timeline-step ce-timeline-step--track' }, [trackRow]));

    // Transition marker between tracks
    if (i < o.tracks.length - 1) {
      (function (tIdx) {
        var tNameEl = el('span', { class: 'ce-ep-transition-name' });
        flowDisplayUpdaters.push(function () {
          var opt = o.transitionOptions.find(function (x) { return x.value === o.editStructure.transitions[tIdx]; });
          tNameEl.textContent = opt ? opt.label : 'Transition';
        });
        var tMarker = el('div', { class: 'ce-ep-transition' }, [
          el('div', { class: 'ce-ep-transition-dot' }),
          el('span', { class: 'ce-ep-transition-label', text: 'T' + (tIdx + 1) + ' · ' }),
          tNameEl,
        ]);
        tMarker.addEventListener('click', function () { o.goToTransitions(); });
        timelineEl.appendChild(el('li', { class: 'ce-timeline-step ce-timeline-step--transition' }, [tMarker]));
      })(i);
    }
  });

  // Outro boundary
  var outroNameEl = el('span', { class: 'ce-ep-boundary-name' });
  flowDisplayUpdaters.push(function () {
    var opt = o.outroOptions.find(function (x) { return x.value === o.editStructure.outro; });
    outroNameEl.textContent = opt ? opt.label : o.editStructure.outro;
  });
  var outroBtn = el('button', { class: 'ce-ep-boundary', type: 'button' }, [
    el('span', { class: 'ce-ep-boundary-tag',  text: 'OUTRO' }),
    outroNameEl,
  ]);
  outroBtn.addEventListener('click', function () { o.goToTransitions(); });
  timelineEl.appendChild(el('li', { class: 'ce-timeline-step ce-timeline-step--outro' }, [outroBtn]));

  flowDisplayUpdaters.forEach(function (fn) { fn(); });
  panel.appendChild(timelineEl);

  // Order at a glance
  panel.appendChild(el('hr', { class: 'ce-page-divider' }));
  panel.appendChild(el('div', { class: 'ce-section-eyebrow', text: 'ORDER AT A GLANCE' }));
  panel.appendChild(el('div', { class: 'ce-section-copy',    text: 'Key details about your order and what to expect.' }));

  var glanceData = [
    ['Package',            stripPrice(o.order.package)],
    ['Dance genre',        stripPrice(o.order.danceGenre)],
    ['Tracks',             String(o.tracks.length)],
    ['Edit points / track', String(epLimit(o.order))],
    ['Turnaround',         stripPrice(o.order.turnaround)],
  ];
  if (o.addOnList.length) glanceData.push(['Add-ons', o.addOnList.join(', ')]);
  if (o.order.submissionDate) glanceData.push(['Est. delivery', estimateDelivery(o.order.submissionDate, o.order.turnaround)]);

  var glanceEl = el('div', { class: 'ce-glance' });
  glanceData.forEach(function (row) {
    glanceEl.appendChild(el('div', { class: 'ce-glance-item' }, [
      el('div', { class: 'ce-glance-label', text: row[0] }),
      el('div', { class: 'ce-glance-value', text: row[1] || '—' }),
    ]));
  });
  panel.appendChild(glanceEl);



  return {
    refreshIncomplete:  function () { buildNextStep(); },
    refreshFlowDisplay: function () { flowDisplayUpdaters.forEach(function (fn) { fn(); }); },
  };
}

// ── buildTrackPanel ───────────────────────────────────────────────────────────

function buildTrackPanel(panel, cfg) {
  var td              = cfg.td;
  var limit           = cfg.limit;
  var maxEffectLevels = cfg.maxEffectLevels || 5;
  var isLocked        = cfg.isLocked || false;

  // Status + save chips
  var statusChip = el('span', { class: 'ce-status-chip' });
  var sc         = makeSaveChip();

  function updateStripStatus() {
    if (td.complete) {
      statusChip.className   = 'ce-status-chip is-ok';
      statusChip.textContent = '✓ Complete';
    } else {
      statusChip.className   = 'ce-status-chip is-warn';
      statusChip.textContent = '⚠ Needs details';
    }
  }
  updateStripStatus();

  function wrappedAutoSave() { sc.trigger(cfg.autoSave); }

  panel.appendChild(makeGuideStrip(
    'TRACK ' + td.track,
    'Add the details for this track',
    'Fill in the information below. Your progress saves automatically.',
    [statusChip, sc.chip]
  ));

  var form = el('div', {});

  // Track Name
  var titleIn = el('input', { class: 'ce-input', type: 'text', placeholder: 'e.g. Finale Song (optional)', value: td.title });
  if (isLocked) titleIn.disabled = true;
  titleIn.addEventListener('input', function () {
    td.title    = titleIn.value;
    td.complete = trackIsComplete(td);
    updateStripStatus();
    cfg.onChange();
  });
  form.appendChild(makeFormRow('Track Name', null, titleIn));

  // Edit Points
  var epContainer  = el('div', {});
  var addEpBtn     = el('button', { class: 'ce-btn ce-btn-outline ce-btn-sm', text: '+ Add edit point', type: 'button', style: 'margin-top:10px;' });
  if (isLocked) addEpBtn.disabled = true;
  var epCountLabel = el('p', { class: 'ce-help', style: 'margin-top:6px;' });

  function updateEpCount() {
    var used = td.editPoints.length;
    epCountLabel.textContent  = used + ' / ' + limit + ' edit points used.';
    epCountLabel.style.color = used >= limit ? 'var(--ce-orange)' : 'var(--ce-muted)';
  }

  function renderEps() {
    epContainer.innerHTML = '';
    td.editPoints.forEach(function (ep, idx) {
      var startIn = el('input', { class: 'ce-input', type: 'text', placeholder: '0:00', value: ep.start || '' });
      var endIn   = el('input', { class: 'ce-input', type: 'text', placeholder: '0:30', value: ep.end   || '' });
      if (isLocked) { startIn.disabled = true; endIn.disabled = true; }
      var durLbl  = el('span',  { class: 'ce-help', style: 'white-space:nowrap;min-width:48px;',
        text: (ep.start && ep.end) ? formatDuration(Math.max(0, parseTime(ep.end) - parseTime(ep.start))) : '' });

      function updateDur() {
        ep.start = startIn.value; ep.end = endIn.value;
        var dur  = parseTime(ep.end) - parseTime(ep.start);
        durLbl.textContent = dur > 0 ? formatDuration(dur) : '';
        td.complete = trackIsComplete(td);
        updateStripStatus();
        cfg.onChange();
      }
      startIn.addEventListener('input', updateDur);
      endIn.addEventListener('input',   updateDur);
      startIn.addEventListener('blur',  wrappedAutoSave);
      endIn.addEventListener('blur',    wrappedAutoSave);

      var removeBtn = el('button', { class: 'ce-btn ce-btn-danger-outline ce-btn-sm', text: 'Remove', type: 'button' });
      if (isLocked) removeBtn.disabled = true;
      (function (capturedIdx) {
        removeBtn.addEventListener('click', function () {
          if (isLocked) return;
          td.editPoints.splice(capturedIdx, 1);
          td.complete = trackIsComplete(td);
          updateStripStatus();
          cfg.onChange();
          wrappedAutoSave();
          renderEps();
        });
      })(idx);


      epContainer.appendChild(el('div', { class: 'ce-ep-row' }, [
        el('span', { style: 'font-size:12px;color:var(--ce-muted);min-width:20px;', text: (idx + 1) + '.' }),
        startIn,
        el('span', { style: 'color:var(--ce-muted);', text: '→' }),
        endIn,
        durLbl,
        removeBtn,
      ]));
    });
    addEpBtn.disabled      = td.editPoints.length >= limit;
    addEpBtn.style.opacity = td.editPoints.length >= limit ? '0.5' : '1';
    updateEpCount();
  }

  if (td.editPoints.length === 0) td.editPoints.push({ start: '', end: '' });
  addEpBtn.addEventListener('click', function () {
    if (td.editPoints.length < limit) { td.editPoints.push({ start: '', end: '' }); renderEps(); }
  });
  renderEps();
  form.appendChild(makeFormRow(
    'Edit Points',
    'An edit point is one section of a track to include. Define a start and end time. Max ' + limit + ' edit point' + (limit !== 1 ? 's' : '') + ' for this track.',
    [epContainer, addEpBtn, epCountLabel]
  ));

  // Effect Level
  var effRow = el('div', { style: 'margin-top:4px;' });
  function renderEffPills() {
    if (isLocked) effRow.style.pointerEvents = 'none';
    effRow.innerHTML = '';
    for (var lvl = 1; lvl <= maxEffectLevels; lvl++) {
      (function (level) {
        var meta = EFFECT_LEVELS[level] || EFFECT_LEVELS[1];
        var pill = el('span', {
          class: 'ce-eff-pill' + (td.effectLevel === level ? ' is-sel' : ''),
          style: 'background:' + meta.bg + ';color:' + meta.text + ';',
          text:  level + ' · ' + meta.label,
        });
        pill.addEventListener('click', function () {
          td.effectLevel = level;
          renderEffPills();
          cfg.onChange();
          wrappedAutoSave();
        });
        effRow.appendChild(pill);
      })(lvl);
    }
  }
  renderEffPills();
  form.appendChild(makeFormRow(
    'Effect Level',
    'Your package allows up to Level ' + maxEffectLevels + '. Higher = more production effects.',
    effRow
  ));

  // Upload
  var fileStatus = el('p', { class: 'ce-help', style: 'margin:0;' + (td.fileUrl ? 'color:var(--ce-accent);' : ''),
    text: td.fileUrl ? '✓ Uploaded: ' + fileName(td.fileUrl) : 'No file uploaded yet.' });
  var ucInput  = el('input', { type: 'hidden', role: 'uploadcare-uploader',
    'data-public-key': cfg.uploadcareKey, 'data-tabs': 'file url',
    'data-multiple': 'false', 'data-images-only': 'false' });
  var chooseBtn  = el('button', { class: 'ce-btn ce-btn-outline ce-btn-sm', text: 'Choose a file', type: 'button' });
  var uploadRow  = el('div', { class: 'ce-upload-row' }, [chooseBtn, fileStatus, ucInput]);

  setTimeout(function () {
    if (window.uploadcare && cfg.uploadcareKey && ucInput.parentNode) {
      try {
        var widget = window.uploadcare.Widget(ucInput);
        chooseBtn.addEventListener('click', function () { widget.openDialog(); });
        widget.onUploadComplete(function (info) {
          td.fileUrl             = info.cdnUrl;
          fileStatus.textContent = '✓ Uploaded: ' + (info.name || fileName(info.cdnUrl));
          fileStatus.style.color = 'var(--ce-accent)';
          td.complete            = trackIsComplete(td);
          updateStripStatus();
          cfg.onChange();
          wrappedAutoSave();
        });
      } catch (_) {}
    }
  }, 150);
  form.appendChild(makeFormRow(
    'Upload',
    'Accepted formats: MP3, WAV, M4A, AIFF. Upload the original full-length track file.',
    uploadRow
  ));

  // Notes
  var notesTA = el('textarea', { class: 'ce-textarea', placeholder: 'e.g. Use the chorus from 1:10, high energy throughout…' });
  if (isLocked) notesTA.disabled = true;
  notesTA.value = td.notes;
  notesTA.addEventListener('input', function () {
    td.notes    = notesTA.value;
    td.complete = trackIsComplete(td);
    updateStripStatus();
    cfg.onChange();
  });
  notesTA.addEventListener('blur', wrappedAutoSave);
  form.appendChild(makeFormRow(
    'Notes',
    'Describe how you want this track used. Minimum 10 characters required.',
    notesTA
  ));

  panel.appendChild(form);

  // Save button
  var saveBtn = el('button', { class: 'ce-btn ce-btn-primary', text: 'Save track', type: 'button', style: 'margin-top:24px;width:100%;' });
  saveBtn.addEventListener('click', function () {
    td.title    = titleIn.value.trim();
    td.notes    = notesTA.value;
    td.complete = trackIsComplete(td);
    updateStripStatus();
    cfg.onChange();
    wrappedAutoSave();
    var ok = td.complete;
    saveBtn.textContent    = ok ? 'Track saved ✓' : '⚠ Incomplete — upload a file, add edit points, and write notes (min 10 chars)';
    saveBtn.style.background = ok ? '' : 'var(--ce-red)';
    setTimeout(function () { saveBtn.textContent = 'Save track'; saveBtn.style.background = ''; }, 3500);
  });
  panel.appendChild(saveBtn);

  // Continue link
  if (cfg.trackIdx !== undefined) {
    var continueLink = el('a', { class: 'ce-continue-link', href: '#' });
    continueLink.textContent = cfg.trackIdx < cfg.trackCount - 1
      ? 'Continue to Track ' + (cfg.trackIdx + 2) + ' →'
      : 'Continue to Transitions →';
    continueLink.addEventListener('click', function (e) {
      e.preventDefault();
      td.title    = titleIn.value.trim();
      td.notes    = notesTA.value;
      td.complete = trackIsComplete(td);
      updateStripStatus();
      cfg.onChange();
      wrappedAutoSave();
      if (typeof cfg.goToNextSubTab === 'function') cfg.goToNextSubTab();
    });
    panel.appendChild(continueLink);
  }
}
// ── buildTransitionsPanel ─────────────────────────────────────────────────────

function buildTransitionsPanel(panel, o) {
  var sc = makeSaveChip();

  function triggerSave() {
    sc.trigger(o.autoSave);
    if (typeof o.onTransitionChange === 'function') o.onTransitionChange();
  }

  panel.appendChild(makeGuideStrip(
    'TRANSITIONS',
    'Shape how your edit comes together.',
    'Choose how your edit begins, how each track connects, and how it finishes. Your selections save automatically.',
    [sc.chip]
  ));

  // Flow preview
  var flowPreview = el('div', { class: 'ce-flow-preview' });

  function updateFlowPreview() {
    flowPreview.innerHTML = '';
    var introOpt = o.introOptions.find(function (x) { return x.value === o.editStructure.intro; });
    flowPreview.appendChild(el('span', { class: 'ce-flow-preview-item', text: 'Intro: ' + (introOpt ? introOpt.label : o.editStructure.intro) }));
    o.tracks.forEach(function (td, i) {
      flowPreview.appendChild(el('span', { class: 'ce-flow-preview-arrow', text: '→' }));
      flowPreview.appendChild(el('span', { class: 'ce-flow-preview-track', text: td.title || 'Track ' + (i + 1) }));
      if (i < o.tracks.length - 1) {
        var tOpt = o.transitionOptions.find(function (x) { return x.value === o.editStructure.transitions[i]; });
        flowPreview.appendChild(el('span', { class: 'ce-flow-preview-arrow', text: '→' }));
        flowPreview.appendChild(el('span', { class: 'ce-flow-preview-item', text: tOpt ? tOpt.label : 'Transition' }));
      }
    });
    flowPreview.appendChild(el('span', { class: 'ce-flow-preview-arrow', text: '→' }));
    var outroOpt = o.outroOptions.find(function (x) { return x.value === o.editStructure.outro; });
    flowPreview.appendChild(el('span', { class: 'ce-flow-preview-item', text: 'Outro: ' + (outroOpt ? outroOpt.label : o.editStructure.outro) }));
  }
  updateFlowPreview();
  panel.appendChild(flowPreview);

  // Form rows
  var formEl = el('div', { class: 'ce-trans-form' });

  function makeTransRow(labelText, copyText, selectEl) {
    return el('div', { class: 'ce-trans-form-row' }, [
      el('div', { class: 'ce-trans-form-label-col' }, [
        el('div', { class: 'ce-trans-form-label', text: labelText }),
        el('div', { class: 'ce-trans-form-copy',  text: copyText }),
      ]),
      el('div', { class: 'ce-trans-form-input-col' }, [selectEl]),
    ]);
  }

  formEl.appendChild(makeTransRow(
    'Intro', 'Choose how your edit begins before the first track.',
    makeSelect(o.introOptions, o.editStructure.intro, function (v) {
      o.editStructure.intro = v; updateFlowPreview(); triggerSave();
    })
  ));

  o.tracks.forEach(function (td, i) {
    if (i < o.tracks.length - 1) {
      (function (idx) {
        var fromName = o.tracks[idx].title     || 'Track ' + (idx + 1);
        var toName   = o.tracks[idx + 1].title || 'Track ' + (idx + 2);
        formEl.appendChild(makeTransRow(
          fromName + ' → ' + toName,
          'Choose how these tracks connect.',
          makeSelect(o.transitionOptions, o.editStructure.transitions[idx] || o.transitionOptions[0].value, function (v) {
            o.editStructure.transitions[idx] = v; updateFlowPreview(); triggerSave();
          })
        ));
      })(i);
    }
  });

  formEl.appendChild(makeTransRow(
    'Outro', 'Choose how your edit finishes after the final track.',
    makeSelect(o.outroOptions, o.editStructure.outro, function (v) {
      o.editStructure.outro = v; updateFlowPreview(); triggerSave();
    })
  ));

  panel.appendChild(formEl);

  var saveBtn = el('button', { class: 'ce-btn ce-btn-primary', text: 'Save transitions', type: 'button', style: 'margin-top:20px;width:100%;' });
  saveBtn.addEventListener('click', function () {
    triggerSave();
    saveBtn.textContent = 'Transitions saved ✓';
    setTimeout(function () { saveBtn.textContent = 'Save transitions'; }, 2500);
  });
  panel.appendChild(saveBtn);

  var continueLink = el('a', { class: 'ce-continue-link', href: '#' });
  if (o.addOnList && o.addOnList.length) {
    continueLink.textContent = 'Continue to Add-ons →';
    continueLink.addEventListener('click', function (e) {
      e.preventDefault(); triggerSave();
      if (typeof o.goToAddOns === 'function') o.goToAddOns();
    });
  } else {
    continueLink.textContent = 'Return to Overview →';
    continueLink.addEventListener('click', function (e) {
      e.preventDefault(); triggerSave();
      if (typeof o.activateTab === 'function') o.activateTab(0);
    });
  }
  panel.appendChild(continueLink);
}

// ── buildAddOnsPanel ──────────────────────────────────────────────────────────

function buildAddOnsPanel(panel, o) {
  var sc          = makeSaveChip();
  var overallChip = el('span', { class: 'ce-status-chip is-ok', text: '✓ Complete' });

  function triggerSave() {
    sc.trigger(o.autoSave);
    if (typeof o.onAddOnChange === 'function') o.onAddOnChange();
  }

  panel.appendChild(makeGuideStrip(
    'ADD-ONS',
    'Finish the details for your edit.',
    'Your selected add-ons are listed below. Complete any remaining options — changes save automatically.',
    [overallChip, sc.chip]
  ));

  if (!o.addOnList || o.addOnList.length === 0) {
    panel.appendChild(el('div', { class: 'ce-addon-empty', text: 'No add-ons included in your package.' }));
    return;
  }

  var addOns     = o.editStructure.addOns;
  var allInfoOnly = true;
  var sectionsEl  = el('div', {});

  function makeTrackOptions() {
    var opts = [{ value: '', label: 'Select track…' }];
    for (var i = 1; i <= o.trackCount; i++) opts.push({ value: String(i), label: 'Track ' + i });
    return opts;
  }

  function makeSection(name, descText, controlsEl, isInfoOnly) {
    var nameRow = el('div', { class: 'ce-addon-section-name' }, [document.createTextNode(name)]);
    if (isInfoOnly) nameRow.appendChild(el('span', { class: 'ce-addon-included', text: '✓ Included' }));
    var section = el('div', { class: 'ce-addon-section' }, [
      nameRow,
      el('div', { class: 'ce-addon-section-desc', text: descText }),
    ]);
    if (controlsEl) section.appendChild(controlsEl);
    return section;
  }

  o.addOnList.forEach(function (name) {
    var lower = name.toLowerCase();
    var sectionEl;

    if (lower.indexOf('clean') !== -1) {
      sectionEl = makeSection(name, 'A clean version will be included with your edit.', null, true);

    } else if (lower.indexOf('speed up') !== -1 || lower.indexOf('slow down') !== -1) {
      allInfoOnly = false;
      var bpmIn = el('input', { class: 'ce-input', type: 'number', placeholder: 'Target BPM (e.g. 128)', value: addOns.bpm || '', style: 'max-width:200px;' });
      bpmIn.addEventListener('input', function () { addOns.bpm = bpmIn.value; triggerSave(); });
      sectionEl = makeSection(name, 'Adjust the tempo of your edit to a specific BPM.', bpmIn, false);

    } else if (lower.indexOf('change key') !== -1) {
      allInfoOnly = false;
      var noteSel = el('select', { class: 'ce-select', style: 'max-width:100px;display:inline-block;' });
      ['A','B','C','D','E','F','G'].forEach(function (n) {
        var opt = el('option', { value: n, text: n });
        if (n === (addOns.key && addOns.key.note)) opt.selected = true;
        noteSel.appendChild(opt);
      });
      noteSel.addEventListener('change', function () { if (!addOns.key) addOns.key = {}; addOns.key.note = noteSel.value; triggerSave(); });
      var typeSel = el('select', { class: 'ce-select', style: 'max-width:120px;display:inline-block;margin-left:8px;' });
      ['Major','Minor'].forEach(function (t) {
        var opt = el('option', { value: t, text: t });
        if (t === (addOns.key && addOns.key.type)) opt.selected = true;
        typeSel.appendChild(opt);
      });
      typeSel.addEventListener('change', function () { if (!addOns.key) addOns.key = {}; addOns.key.type = typeSel.value; triggerSave(); });
      sectionEl = makeSection(name, 'Choose the key for your completed edit.', el('div', { class: 'ce-addon-inline-group' }, [noteSel, typeSel]), false);

    } else if (lower.indexOf('custom intro') !== -1) {
      allInfoOnly = false;
      var ciIn = el('input', { class: 'ce-input', type: 'text', placeholder: 'Describe your custom intro…', value: addOns.customIntro || '' });
      ciIn.addEventListener('input', function () { addOns.customIntro = ciIn.value; triggerSave(); });
      sectionEl = makeSection(name, 'Describe the custom intro you would like for your edit.', ciIn, false);

    } else if (lower.indexOf('custom outro') !== -1) {
      allInfoOnly = false;
      var coIn = el('input', { class: 'ce-input', type: 'text', placeholder: 'Describe your custom outro…', value: addOns.customOutro || '' });
      coIn.addEventListener('input', function () { addOns.customOutro = coIn.value; triggerSave(); });
      sectionEl = makeSection(name, 'Describe the custom outro you would like for your edit.', coIn, false);

    } else if (lower.indexOf('acapella') !== -1) {
      allInfoOnly = false;
      var acapTrackSel = makeSelect(makeTrackOptions(), addOns.acapellaTrack || '', function (v) { addOns.acapellaTrack = v; triggerSave(); });
      var acapIn = el('input', { class: 'ce-input', type: 'text', placeholder: 'Any specific instructions…', value: addOns.acapella || '', style: 'margin-top:8px;' });
      acapIn.addEventListener('input', function () { addOns.acapella = acapIn.value; triggerSave(); });
      sectionEl = makeSection(name, 'Isolate the vocals on a specific track.', el('div', {}, [
        el('div', { class: 'ce-addon-section-desc', text: 'Apply to track' }),
        acapTrackSel,
        el('div', { class: 'ce-addon-section-desc', style: 'margin-top:8px;', text: 'Instructions' }),
        acapIn,
      ]), false);

    } else if (lower.indexOf('remove noise') !== -1) {
      allInfoOnly = false;
      var noiseTrackSel = makeSelect(makeTrackOptions(), addOns.removeNoiseTrack || '', function (v) { addOns.removeNoiseTrack = v; triggerSave(); });
      var noiseIn = el('input', { class: 'ce-input', type: 'text', placeholder: 'Describe the noise or section to clean…', value: addOns.removeNoise || '', style: 'margin-top:8px;' });
      noiseIn.addEventListener('input', function () { addOns.removeNoise = noiseIn.value; triggerSave(); });
      sectionEl = makeSection(name, 'Remove background noise or unwanted audio from a track.', el('div', {}, [
        el('div', { class: 'ce-addon-section-desc', text: 'Apply to track' }),
        noiseTrackSel,
        el('div', { class: 'ce-addon-section-desc', style: 'margin-top:8px;', text: 'Instructions' }),
        noiseIn,
      ]), false);

    } else if (lower.indexOf('custom dance break') !== -1) {
      allInfoOnly = false;
      var cdbIn = el('input', { class: 'ce-input', type: 'text', placeholder: 'Describe your custom dance break…', value: addOns.customDanceBreak || '' });
      cdbIn.addEventListener('input', function () { addOns.customDanceBreak = cdbIn.value; triggerSave(); });
      sectionEl = makeSection(name, 'Add a custom dance break section to your edit.', el('div', {}, [
        el('div', { class: 'ce-addon-section-desc', text: 'Limited to 1 per order.' }),
        cdbIn,
      ]), false);

    } else {
      allInfoOnly = false;
      var otherIn = el('input', { class: 'ce-input', type: 'text', placeholder: 'Instructions for ' + name + '…', value: (addOns.other && addOns.other[name]) || '' });
      otherIn.addEventListener('input', function () { if (!addOns.other) addOns.other = {}; addOns.other[name] = otherIn.value; triggerSave(); });
      sectionEl = makeSection(name, '', otherIn, false);
    }

    sectionsEl.appendChild(sectionEl);
  });

  panel.appendChild(sectionsEl);

  if (allInfoOnly) {
    overallChip.textContent = '✓ Included';
    panel.appendChild(el('div', {
      style: 'background:var(--ce-accent-bg);border-left:4px solid var(--ce-accent);padding:14px 18px;border-radius:0 8px 8px 0;margin:16px 0;font-weight:600;color:var(--ce-accent);',
      text: '✓ All add-on details are complete.',
    }));
  } else {
    var saveBtn = el('button', { class: 'ce-btn ce-btn-primary', text: 'Save add-ons', type: 'button', style: 'margin-top:24px;width:100%;' });
    saveBtn.addEventListener('click', function () {
      triggerSave();
      saveBtn.textContent = 'Add-ons saved ✓';
      setTimeout(function () { saveBtn.textContent = 'Save add-ons'; }, 2500);
    });
    panel.appendChild(saveBtn);
  }

  var returnLink = el('a', { class: 'ce-continue-link', href: '#', text: 'Return to Overview →' });
  returnLink.addEventListener('click', function (e) {
    e.preventDefault();
    if (!allInfoOnly) triggerSave();
    if (typeof o.activateTab === 'function') o.activateTab(0);
  });
  panel.appendChild(returnLink);
}

// ── buildHelpPanel ────────────────────────────────────────────────────────────

function buildHelpPanel(panel, o) {
  var c = o.order.content || {};
  var wrap = el('div', { class: 'ce-help-page' });

  wrap.appendChild(el('div', { class: 'ce-section-eyebrow', text: 'HELP WITH YOUR EDIT' }));
  wrap.appendChild(el('div', { class: 'ce-section-title',   text: 'Everything you need to prepare your edit.' }));
  wrap.appendChild(el('div', { class: 'ce-section-copy',    text: 'Follow these steps to send through your music and instructions. Your progress saves automatically as you go.' }));

  var quickLinks = [
    { label: 'Getting started', id: 'help-step-1' },
    { label: 'Edit points',     id: 'help-step-2' },
    { label: 'Transitions',     id: 'help-step-3' },
    { label: 'Submitting',      id: 'help-step-4' },
    { label: 'Download',        id: 'help-step-5' },
    { label: 'Contact',         id: 'help-contact' },
  ];
  var qlRow = el('div', { class: 'ce-help-quick-links' });
  quickLinks.forEach(function (ql) {
    var btn = el('button', { class: 'ce-help-quick-link', text: ql.label, type: 'button' });
    btn.addEventListener('click', function () {
      var target = panel.querySelector('#' + ql.id);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    qlRow.appendChild(btn);
  });
  wrap.appendChild(qlRow);

  function makeStep(id, num, heading, copy, actionLabel, onAction, extraEl) {
    var stepEl = el('li', { class: 'ce-process-step', id: id });
    stepEl.appendChild(el('div', { class: 'ce-process-num', text: String(num) }));
    var body = el('div', { class: 'ce-process-body' });
    body.appendChild(el('div', { class: 'ce-process-heading', text: heading }));
    body.appendChild(el('div', { class: 'ce-process-copy',    text: copy }));
    if (extraEl) body.appendChild(extraEl);
    if (actionLabel && onAction) {
      var actionBtn = el('button', { class: 'ce-process-action', text: actionLabel, type: 'button' });
      actionBtn.addEventListener('click', onAction);
      body.appendChild(actionBtn);
    }
    stepEl.appendChild(body);
    return stepEl;
  }

  var processList = el('ol', { class: 'ce-process-list' });

  processList.appendChild(makeStep('help-step-1', 1,
    c.help_step_1_heading || 'Add your tracks',
    c.help_step_1_copy    || 'Go to Build Your Edit, select each track, upload your audio file, add edit points, and leave any notes for your editor.',
    'Build your edit →', function () { o.activateTab(1); }
  ));

  var disclosureVisible = false;
  var disclosureBody    = el('div', { class: 'ce-disclosure-body',
    text: 'An edit point is one section of a song defined by a start and end time. For example, Start 0:32 to End 1:08 means use that 36-second section of the track. You can add multiple edit points per track up to your package limit.' });
  disclosureBody.style.display = 'none';
  var disclosureToggle = el('button', { class: 'ce-disclosure-toggle', text: 'What is an edit point?', type: 'button' });
  disclosureToggle.addEventListener('click', function () {
    disclosureVisible = !disclosureVisible;
    disclosureBody.style.display  = disclosureVisible ? 'block' : 'none';
    disclosureToggle.textContent  = disclosureVisible ? 'Hide explanation' : 'What is an edit point?';
  });

  processList.appendChild(makeStep('help-step-2', 2,
    c.help_step_2_heading || 'Choose your edit points',
    c.help_step_2_copy    || 'Edit points tell us which sections of a song to use. Each point has a start and end time.',
    null, null, el('div', {}, [disclosureToggle, disclosureBody])
  ));

  processList.appendChild(makeStep('help-step-3', 3,
    c.help_step_3_heading || 'Set your transitions',
    c.help_step_3_copy    || 'Use the Transitions section under Build Your Edit to choose your intro, how tracks connect, and your outro style.',
    'Choose transitions →', function () { o.goToTransitions(); }
  ));

  var submitStatusEl = el('div', { class: 'ce-process-status' });
  function updateSubmitStatus() {
    var allDone     = o.tracks.every(function (t) { return t.complete; });
    var isSubmitted = ['submitted','ready','completed'].indexOf(o.order.status) !== -1;
    if (isSubmitted) {
      submitStatusEl.className   = 'ce-process-status is-ready';
      submitStatusEl.textContent = '✓ Your edit has been submitted.';
    } else if (allDone) {
      submitStatusEl.className   = 'ce-process-status is-ready';
      submitStatusEl.textContent = '✓ Your edit is ready to submit.';
    } else {
      submitStatusEl.className   = 'ce-process-status is-pending';
      submitStatusEl.textContent = 'Complete your remaining track details to unlock submission.';
    }
  }
  updateSubmitStatus();

  processList.appendChild(makeStep('help-step-4', 4,
    c.help_step_4_heading || 'Review and submit',
    c.help_step_4_copy    || 'Once every required track is complete, return to Overview and submit your edit for processing.',
    'Go to Overview →', function () { o.activateTab(0); },
    submitStatusEl
  ));

  processList.appendChild(makeStep('help-step-5', 5,
    c.help_step_5_heading || 'Download your completed edit',
    c.help_step_5_copy    || 'When your edit is ready, it will appear in the Download tab. You can return there at any time to check its status.',
    'View download status →', function () { o.activateTab(3); }
  ));

  wrap.appendChild(processList);
  wrap.appendChild(el('hr', { class: 'ce-accent-divider' }));

  var contactEl = el('div', { class: 'ce-contact-area', id: 'help-contact' });
  contactEl.appendChild(el('div', { class: 'ce-section-eyebrow', text: 'NEED HELP?' }));
  contactEl.appendChild(el('div', { class: 'ce-section-title',   text: 'Get in touch' }));
  contactEl.appendChild(el('p',   { class: 'ce-section-copy',    text: 'If you have any questions about your order, reach out and we\'ll get back to you as soon as possible.' }));
  var contactLink = el('a', { class: 'ce-btn ce-btn-outline', href: 'mailto:hello@rhythmixed.co', text: 'Email us →' });
  contactEl.appendChild(contactLink);
  wrap.appendChild(contactEl);

  panel.appendChild(wrap);
}

// ── buildDownloadSection ──────────────────────────────────────────────────────

function buildDownloadSection(panel, order, ctx) {
  var dlUrl = order.deliveryUrl || order.downloadUrl || order.delivery_url || order.fileUrl || null;

  var states = {
    pending:   { badge: 'is-pending',   label: 'Not submitted', title: 'Not submitted yet',        copy: 'Complete your track details and submit your edit to get started.' },
    submitted: { badge: 'is-submitted', label: 'In progress',   title: 'We\'re working on it',     copy: 'Your edit has been received and is in the queue. We\'ll be in touch when it\'s ready.' },
    ready:     { badge: 'is-ready',     label: 'Ready',         title: 'Your edit is ready',       copy: 'Your completed edit is ready to download.' },
    completed: { badge: 'is-completed', label: 'Delivered',     title: 'Edit delivered',           copy: 'Your edit has been delivered. You can re-download it below anytime.' },
  };

  var s    = states[order.status] || states['pending'];
  var wrap = el('div', { class: 'ce-dl-panel' });

  wrap.appendChild(el('div', { class: 'ce-dl-status-badge ' + s.badge, text: s.label }));
  wrap.appendChild(el('div', { class: 'ce-dl-title', text: s.title }));
  wrap.appendChild(el('div', { class: 'ce-dl-copy',  text: s.copy }));

  var actions = el('div', { class: 'ce-dl-actions' });

  if (dlUrl) {
    actions.appendChild(el('a', {
      class:  'ce-btn ce-btn-primary',
      href:   dlUrl,
      target: '_blank',
      rel:    'noopener noreferrer',
      text:   'Download your edit →',
    }));
  } else if (order.status === 'pending' || !order.status) {
    var goBtn = el('button', { class: 'ce-btn ce-btn-outline', text: 'Go to Build Your Edit →', type: 'button' });
    goBtn.addEventListener('click', function () { ctx.activateTab(1); });
    actions.appendChild(goBtn);
  }

  var refreshBtn = el('button', { class: 'ce-btn ce-btn-outline ce-btn-sm', text: 'Refresh', type: 'button' });
  refreshBtn.addEventListener('click', function () {
    refreshBtn.disabled    = true;
    refreshBtn.textContent = 'Refreshing…';
    if (typeof ctx.onRefresh === 'function') ctx.onRefresh();
    setTimeout(function () { refreshBtn.disabled = false; refreshBtn.textContent = 'Refresh'; }, 2000);
  });
  actions.appendChild(refreshBtn);

  wrap.appendChild(actions);
  panel.appendChild(wrap);
}

